module.exports = __webpack_public_path__ + "7d037dfcf6886e077b24488ea6349def.png";